import React, { useState } from "react";
import "./iframe.css";
import { Button } from "@material-ui/core";
import axios from "axios";
import VideoComponent from "./VideoComponent";

const VideoPlayer = (props) => {
  const { videoLink } = props.location.state;
  const { genre } = props.location.state;
  const { title } = props.location.state;
  const { contentRating } = props.location.state;
  const { viewCount } = props.location.state;
  const [likes, setlikes] = useState(0);
  const [dislikes, setDislikes] = useState(0);

  const handleLikeClicks = () => {
    setlikes(likes + 1);
  };
  const handleDislikeClicks = () => {
    setDislikes(dislikes + 1);
  };

  return (
    <div
      style={{
        backgroundColor: "#181818",
        display: "grid",
        gridTemplateColumns: "1fr",
        gridTemplateRows: "500px auto",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <iframe
        className="iframe"
        src={encodeURI(`https://${videoLink}`)}
        title="Video Player"
        width="1000px"
        height="500px"
        allowFullScreen
        style={{ margin: "0 auto" }}
      ></iframe>

      <div
        id="description"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "90%",
          marginLeft: "80px",
          padding: "10px",
        }}
      >
        <div
          id="title"
          className="videoDescription"
          style={{ marginBottom: "10px", marginLeft: "170px" }}
        >
          {`${title}`}
          <div style={{ display: "flex" }}>
            <span
              id="rating"
              style={{ marginRight: "10px" }}
              className="videoDescription"
            >
              {`${contentRating}`}
            </span>
            <span id="genre" className="videoDescription">{`${genre}`}</span>
          </div>
        </div>
        <div
          id="voting-btn"
          style={{ display: "flex", alignItems: "center", marginRight: "170px" }}
        >
          <Button
            onClick={handleLikeClicks}
            style={{
              backgroundColor: "#4ca3fc",
              color: "white",
              marginRight: "3px",
            }}
            variant="outlined"
          >
            like {likes}
          </Button>
          <Button
            onClick={handleDislikeClicks}
            style={{ backgroundColor: "#4ca3fc", color: "white" }}
            variant="outlined"
          >
            dislike {dislikes}
          </Button>
          <div id="VideoCounts" style={{ marginLeft: "10px" }}>
            {`${viewCount}`} Views
          </div>
        </div>
      </div>

      <hr style={{ width: "60%", color: "#a59ea0" }} />

      <div style={{ padding: "10px" }}>
        <VideoComponent />
      </div>
    </div>
  );
};

export default VideoPlayer;